/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-question-look-1': {
    width: 50,
    height: 34,
    viewBox: '0 0 50 34',
    data: '<path pid="0" class="st0" d="M3.1 27.6h43v2.7h-43v-2.7zm.5-5.5c.6-.9 1.7-1.4 3.2-1.7 1.5-.3 3.4-.7 5.3-1.3.6.9 1.4 2.8 1 5.5H3c0-.4-.1-1.5.6-2.5m15.7-5.8c.5-.2 1-.5 1.6-.8l2.7 4.4 2.6-1.6-2.7-4.3c.7-.5 1.4-.9 2.1-1.5l3.4 3.6 2.2-2.1-3.4-3.6c.6-.6 1-1.3 1.4-2l3.9 2.8 1.7-2.5-4.6-3.2c.2-.8.4-1.7.6-2.5h15.3v21.6h-30c.3-2.9-.4-5.1-1.2-6.5 1.5-.6 3-1.2 4.4-1.8M28.2 0L28 1.3c-.2 2-.7 3.9-1.4 5.6-.9 2.1-3.9 4.5-8.6 6.7-4.4 2.1-9 3.4-11.7 3.9-2.4.4-4.2 1.4-5.2 3-1.3 2-1.1 4.1-1 4.7v8.2h49V0H28.2z"/><path pid="1" class="st0" d="M39.3 16.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5m0 6c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5-4.5 2-4.5 4.5 2 4.5 4.5 4.5"/>'
  }
})
